import { manifesto } from "@/lib/siteData";
import { Reveal } from "./Primitives";

export const Manifesto = () => (
  <section className="relative border-y border-white/5 bg-[#0F0F1A]/50 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-16">
        <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Nosso diferencial</span>
        <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">Por que nós?</h2>
      </Reveal>

      <div className="space-y-4">
        {manifesto.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.1}>
            <div
              data-testid={`manifesto-${m.n}`}
              className="group grid grid-cols-1 items-center gap-4 border-t border-white/10 py-8 md:grid-cols-12"
            >
              <div className="font-display text-6xl font-black text-stroke transition-colors md:col-span-2 md:text-8xl group-hover:[--tw-text-opacity:1]">
                {m.n}
              </div>
              <h3 className="font-display text-2xl font-bold tracking-tight md:col-span-4 md:text-3xl">{m.title}</h3>
              <p className="font-body text-slate-400 md:col-span-6 md:text-lg">{m.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
